/**
 * Per-install stable device ID. Stored in localStorage (survives reloads,
 * lost on a full browser data clear — same fate as uninstalling the
 * Android app, so the semantics match).
 */

const KEY = 'shell.deviceId';

export function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}
